import type { TFilter } from '../types';

import FilterMultiSelect from './FilterMultiSelect';
import FilterSingleSelect from './FilterSingleSelect';

function FilterContentSwitch<FT extends TFilter>({
  filter,
  value,
  onChange,
  onSubmit,
  onClear,
}: {
  filter: FT;
  value?: FT extends TFilter<infer VT> ? VT[] : never;
  onChange: (value: FT extends TFilter<infer VT> ? VT[] : never) => void;
  onSubmit: (value?: FT extends TFilter<infer VT> ? VT[] : never) => void;
  onClear: (e: React.MouseEvent<HTMLButtonElement>) => (key: string) => void;
}) {
  switch (filter.type) {
    case 'single-select':
      return <FilterSingleSelect value={value} filter={filter} onSubmit={onSubmit} />;
    case 'multi-select':
      return <FilterMultiSelect filter={filter} onChange={onChange} value={value} onClear={onClear} />;
    default:
      return null;
  }
}

export default FilterContentSwitch;
